export default __webpack_public_path__ + "static/media/brand.4a81d569.png";